import axios, { AxiosRequestConfig } from "axios";
import { injectAuthHeaderIfNotPresent } from "../../http/customAxios";

/**
 * Wraps an axios instance which can then provides
 * get, post, put, delete, etc methods
 *
 * @param  {string} baseURL       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           An object containing either "data" or "err"
 */
// TODO: replace with httpclient
export const create = ({
  baseURL,
  ...options
}: {
  baseURL: string;
  options: AxiosRequestConfig;
}) => {
  const axiosInstance = axios.create({
    baseURL,
    timeout: 120000,
    headers: {},
    ...options,
  });
  axiosInstance.interceptors.request.use(injectAuthHeaderIfNotPresent);
  return axiosInstance;
};

export default {
  create,
};

const BASE_URL = window.CONFIG?.apiEndpoint;
const BACKOFFICE_URL = "";
const BACKOFFICE_MANAGER_URL = "/v6/api";
const MIDDLEWARE_URL = window.CONFIG?.middlewareEndpoint;
const API_PAYMENTS_URL = window.CONFIG?.paymentsApiEndpoint;

export { BASE_URL, BACKOFFICE_URL, MIDDLEWARE_URL, BACKOFFICE_MANAGER_URL, API_PAYMENTS_URL };
